import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BusyService {
  private busySubject = new BehaviorSubject<boolean>(false);
  isBusy$ = this.busySubject.asObservable();

  setBusy(value: boolean) {
    setTimeout(() => {
      this.busySubject.next(value);
    });    
  }
}
